var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("download-trial-modal"),
      _c("watermark-modal"),
      _vm.showNav
        ? _c(
            "headroom",
            {
              staticClass: "site_header",
              attrs: { upTolerance: 0, downTolerance: 0 }
            },
            [
              _c(
                "div",
                { staticClass: "nav__section" },
                [
                  _c(
                    "router-link",
                    { staticClass: "logo", attrs: { to: "/" } },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.flixel.com/static/static-web/logos/logo__white.png"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "nav__section nav__desktop" }, [
                _c("ul", { staticClass: "drop-menu" }, [
                  _c("li", { staticClass: "nav__item" }, [
                    _c("h1", [_vm._v("Products")]),
                    _c("ul", { staticClass: "sub-menu nav__width--products" }, [
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/products/mac/cinemagraph-pro/" } },
                            [
                              _vm._v("Cinemagraph Pro"),
                              _c("span", [_vm._v(" macOS")])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/products/ios/cinemagraph-pro/" } },
                            [
                              _vm._v("Cinemagraph Pro"),
                              _c("span", [_vm._v(" iOS")])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/products/ios/blendeo/" } },
                            [_vm._v("Blendeo"), _c("span", [_vm._v(" iOS")])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/products/mac/persecond/" } },
                            [
                              _vm._v("Persecond"),
                              _c("span", [_vm._v(" macOS")])
                            ]
                          )
                        ],
                        1
                      ),
                      _c("li", { staticClass: "underline" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://itunes.apple.com/ca/app/flixel-tv/id1043381618?mt=8"
                            }
                          },
                          [_vm._v("Flixel TV"), _c("span", [_vm._v(" tvOS")])]
                        )
                      ]),
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/products/hosting/" } },
                            [_vm._v("Cinemagraph Hosting")]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _c(
                    "li",
                    { staticClass: "nav__item" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/products/pricing/" } },
                        [_c("h1", [_vm._v("Pricing")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    { staticClass: "nav__item" },
                    [
                      _c("router-link", { attrs: { to: "/studios/" } }, [
                        _c("h1", [_vm._v("Services")])
                      ])
                    ],
                    1
                  ),
                  _c("li", { staticClass: "nav__item" }, [
                    _c("h1", [_vm._v("Company")]),
                    _c("ul", { staticClass: "sub-menu" }, [
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c("router-link", { attrs: { to: "/company/" } }, [
                            _vm._v("About Flixel")
                          ])
                        ],
                        1
                      ),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { href: "http://blog.flixel.com/contact/" }
                          },
                          [_vm._v("Contact")]
                        )
                      ])
                    ])
                  ]),
                  _c("li", { staticClass: "nav__item" }, [
                    _c("h1", [_vm._v("Learn")]),
                    _c("ul", { staticClass: "sub-menu" }, [
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c("router-link", { attrs: { to: "/tutorials/" } }, [
                            _vm._v("Tutorials")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "li",
                        { staticClass: "underline" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/case-studies/" } },
                            [_vm._v("Case Studies")]
                          )
                        ],
                        1
                      ),
                      _c("li", { staticClass: "underline" }, [
                        _c(
                          "a",
                          { attrs: { href: "http://support.flixel.com/" } },
                          [_vm._v("Help Center")]
                        )
                      ]),
                      _c("li", [
                        _c(
                          "a",
                          { attrs: { href: "http://forums.flixel.com" } },
                          [_vm._v("Forums")]
                        )
                      ])
                    ])
                  ]),
                  _c("li", { staticClass: "nav__item" }, [
                    _c("a", { attrs: { href: "http://blog.flixel.com/" } }, [
                      _c("h1", [_vm._v("Blog")])
                    ])
                  ]),
                  _c(
                    "li",
                    { staticClass: "nav__item" },
                    [
                      _c("router-link", { attrs: { to: "/cinemagraphs/" } }, [
                        _c("h1", [_vm._v("Gallery")])
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "nav__section", attrs: { id: "sign-in" } },
                [
                  _c("ul", { staticClass: "drop-menu" }, [
                    _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.profile,
                            expression: "!profile"
                          }
                        ]
                      },
                      [
                        _c("router-link", { attrs: { to: "/login/" } }, [
                          _vm._v("Sign In")
                        ])
                      ],
                      1
                    ),
                    _vm.profile
                      ? _c(
                          "li",
                          { staticClass: "profile", attrs: { id: "profile" } },
                          [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.profile.avatar }
                            }),
                            _c(
                              "ul",
                              {
                                staticClass: "sub-menu",
                                attrs: { id: "profileMenu" }
                              },
                              [
                                _c("li", { staticClass: "underline" }, [
                                  _c("h2", [
                                    _vm._v(_vm._s(_vm.account.username))
                                  ]),
                                  _c(
                                    "h3",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.GoTo(
                                            "Profile",
                                            _vm.account.username
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("View profile >")]
                                  )
                                ]),
                                _c("li", { staticClass: "underline" }, [
                                  _c(
                                    "h3",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.GoTo("Settings")
                                        }
                                      }
                                    },
                                    [_vm._v("Account Settings")]
                                  ),
                                  _c(
                                    "h3",
                                    { on: { click: _vm.openWatermarkEmbed } },
                                    [_vm._v("Watermarks")]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "http://support.flixel.com/"
                                      }
                                    },
                                    [_c("h3", [_vm._v("Help")])]
                                  )
                                ]),
                                _c("li", [
                                  _c(
                                    "h3",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.logout()
                                        }
                                      }
                                    },
                                    [_vm._v("Log out")]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm.freePlan
                    ? _c(
                        "router-link",
                        {
                          staticClass: "btn btn--blue btn--download",
                          attrs: { to: "products.pricing" }
                        },
                        [_vm._v("Get a Plan")]
                      )
                    : _vm._e(),
                  _vm.downloadButtoniOS
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn--blue btn--download",
                          attrs: {
                            href:
                              "https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8"
                          }
                        },
                        [_vm._v("Download")]
                      )
                    : _vm._e(),
                  _vm.downloadButtonPersecond
                    ? _c("download-trial-button", {
                        attrs: {
                          product: "persecond",
                          classes: "btn btn--blue btn--download",
                          copy: "Download"
                        }
                      })
                    : _vm._e(),
                  _vm.downloadButtonBlendeo
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn--blue btn--download",
                          attrs: { href: "http://apple.co/Blendeo" }
                        },
                        [_vm._v("Download")]
                      )
                    : _vm._e(),
                  _vm.downloadButtonPro
                    ? _c("download-trial-button", {
                        attrs: {
                          product: "pro",
                          classes: "btn btn--blue btn--download",
                          copy: "Download"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "nav__section nav__menu",
                  model: {
                    value: _vm.showMobileMenu,
                    callback: function($$v) {
                      _vm.showMobileMenu = $$v
                    },
                    expression: "showMobileMenu"
                  }
                },
                [
                  _c("a", {
                    staticClass: "fa fa-bars",
                    attrs: { id: "nav--icon" },
                    on: {
                      click: function($event) {
                        _vm.showMobileMenu = true
                      }
                    }
                  }),
                  _vm.showMobileMenu
                    ? _c("div", { staticClass: "mobile__nav" }, [
                        _vm.showMobileMenu
                          ? _c("a", {
                              staticClass: "close",
                              on: {
                                click: function($event) {
                                  _vm.showMobileMenu = false
                                }
                              }
                            })
                          : _vm._e(),
                        _c("div", { staticClass: "nav__list" }, [
                          _c("ul", [
                            _vm.profile
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav__item nav__item--mobile"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.GoTo(
                                              "Profile",
                                              _vm.account.username
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Profile")]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.profile
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav__item nav__item--mobile"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.GoTo("Settings")
                                          }
                                        }
                                      },
                                      [_vm._v("Account Settings")]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.profile
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav__item nav__item--mobile"
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: "/login/" } },
                                      [_vm._v("Sign in")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/products/mac/cinemagraph-pro/"
                                    }
                                  },
                                  [_vm._v("Cinemagraph Pro")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/products/ios/cinemagraph-pro/"
                                    }
                                  },
                                  [_vm._v("Cinemagraph Pro iOS")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/products/ios/blendeo/" } },
                                  [_vm._v("Blendeo")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/products/mac/persecond/" } },
                                  [_vm._v("Persecond")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/products/hosting/" } },
                                  [_vm._v("Cinemagraph Hosting")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/products/pricing/" } },
                                  [_vm._v("Pricing")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/studios/" } },
                                  [_vm._v("Services")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/cinemagraphs/" } },
                                  [_vm._v("Gallery")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/tutorials/" } },
                                  [_vm._v("Tutorials")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "http://forums.flixel.com" }
                                  },
                                  [_vm._v("Forums")]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/case-studies/" } },
                                  [_vm._v("Case Studies")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "http://blog.flixel.com/" }
                                  },
                                  [_vm._v("Blog")]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              { staticClass: "nav__item nav__item--mobile" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "http://support.flixel.com/"
                                    }
                                  },
                                  [_vm._v("Help")]
                                )
                              ]
                            ),
                            _vm.profile
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav__item nav__item--mobile"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.logout()
                                          }
                                        }
                                      },
                                      [_vm._v("Log out")]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81440b78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = null
// module chunks = 